<template>
  <a :href="url" :target="target" @click="onClick"><slot /></a>
</template>

<script>
import { isWebView } from '@/utils/device'

/**
 * 別タブで URL を開きます。
 * アプリの場合は browser=safari を付与、自ドメインではトークンの付与も行います。
 */
export default {
  name: 'BrowserOpen',
  props: {
    url: String,
    target: { type: String, default: '_blank' },
  },
  methods: {
    async onClick(e) {
      if (!isWebView()) return
      e.preventDefault()
      const openUrl = new URL(this.url, location.href)

      let token
      if (openUrl.hostname === location.hostname) {
        token = await this.$store.dispatch('token/get', this.url)
        if (!token) return
        openUrl.searchParams.append('token', token)
      }

      openUrl.searchParams.append('browser', 'safari')
      location.assign(openUrl.href)
    },
  },
}
</script>
